import { createAsyncThunk } from "@reduxjs/toolkit";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import { UserData } from "@/entities/User";
import { handleError } from "@/shared/lib/helpers/utils";
import { ApiError } from "@/shared/types";

export const updateProfile = createAsyncThunk<UserData, { params: Partial<UserData> }, ThunkConfig<ApiError>>(
  "auth/updateProfile",
  async ({ params }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      const response = await extra.api.patch<UserData>("/api/users-me", params);

      return response.data;
    } catch (err) {
      return rejectWithValue(handleError(err));
    }
  }
);
